export default {
      id: "flex-justifyContent-flex-end-usage",
      viewBox: "0 0 40 40",
      url: "assets/" + "sprite.svg#flex-justifyContent-flex-end-usage",
      toString: function () {
        return this.url;
      }
    }